import React, { useState } from 'react'
import styled from 'styled-components'

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  h2 {
    font-size: var(--fontSize-2);
    margin: 0;
  }
  button {
    font-size: var(--fontSize-0);
    padding: var(--spacing-1) var(--spacing-4);
    border: none;
    border-radius: var(--spacing-4);
    background: #e4e4e4;
    color: #656565;
    cursor: pointer;
  }
`

const Headings = styled.section`
  padding: 0 var(--spacing-4);
  margin-bottom: 0;
  font-size: 0.8rem;
  ul {
    margin: var(--spacing-2);
  }
  li {
    margin: var(--spacing-1) 0;
  }
  p {
    margin: 0;
  }
`

const StyledTableOfContents = styled.div`
  margin-bottom: var(--spacing-6);
  padding: var(--spacing-4);
  border-radius: 0.5rem;
  background: #eaedf1;
`

export const TableOfContents = ({ html }) => {
  const [isVisible, setVisible] = useState(false)
  const toggle = () => setVisible(!isVisible)

  return (
    <StyledTableOfContents>
      <Header>
        <h2>Xem nhanh</h2>
        <button onClick={toggle}>{isVisible ? `Ẩn` : `Hiện`}</button>
      </Header>
      {isVisible && <Headings dangerouslySetInnerHTML={{ __html: html }} />}
    </StyledTableOfContents>
  )
}
